/**
 * Patches `Node.prototype.removeChild` and `Node.prototype.insertBefore` to
 * silently handle the case where an external actor (browser extensions, Google
 * Translate, ad-blockers, etc.) has already moved or removed a DOM node that
 * React still expects to be present. Without this patch React throws
 * "Failed to execute 'removeChild' on 'Node'" and the user sees the error page.
 *
 * Must be called **before** `ReactDOM.createRoot` so the patched methods are in
 * place by the time React starts reconciling the DOM.
 */
export const patchDomForThirdPartyMutations = () => {
  const { removeChild } = Node.prototype;

  Node.prototype.removeChild = function <T extends Node>(child: T): T {
    if (child.parentNode !== this) {
      return child;
    }
    return removeChild.call(this, child) as T;
  };

  const { insertBefore } = Node.prototype;

  Node.prototype.insertBefore = function <T extends Node>(newNode: T, refNode: Node | null): T {
    if (refNode && refNode.parentNode !== this) {
      return newNode;
    }
    return insertBefore.call(this, newNode, refNode) as T;
  };
};
